import { ApolloClient, ApolloLink, HttpLink } from '@apollo/client'
import { CombinedGraphQLErrors } from '@apollo/client/errors'
import { ErrorLink } from '@apollo/client/link/error'
import { cache } from '@cache'
import User from '@utils/storage/user'

const errorLink = new ErrorLink(({ error }) => {
  if (CombinedGraphQLErrors.is(error)) {
    error.errors.forEach(({ message, extensions, locations, path }) => {
      console.warn(
        `[GraphQL error]: Message: ${message}, `,
        `Extensions: ${extensions}, `,
        `Location: ${locations}, `,
        `Path: ${path}`
      )

      if (extensions?.code === 'UNAUTHORIZED') {
        User.clear()

        window.location.assign('/login')
      }
    })
  } else {
    console.warn(`[Network error]: ${error}`)
  }

  if (error?.statusCode === 401 || error?.response?.status === 401) {
    User.clear()

    window.location.assign('/login')
  }
})

const httpLink = new HttpLink({
  uri: Settings.GRAPHQL_ENDPOINT,
  credentials: 'include'
})

const apolloClient = new ApolloClient({
  cache,
  link: ApolloLink.from([errorLink, httpLink])
})

export default apolloClient
